/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  // isSplash: true, // Change this to false if you don't want Splash screen.
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Ethen's Portfolio",
  description:
  "A passionate individual who thrives on delving into the fascinating world of robotics, machine learning, computer vision, and autonomous vehicles.",
  og: {
    title: "Lin-Hsi (Ethen) Tsao Portfolio",
    type: "website",
    url: "http://lintsao.github.io",
  },
};

//Home Page
const greeting = {
  title: "Lin-Hsi (Ethen) Tsao",
  logo_name: "LinHsiTsao",
  nickname: "Tsao Lin",
  subTitle:
    "A passionate individual delving into the fascinating world of robotics, machine learning, computer vision, and autonomous vehicles.",
  resumeLink:
    "https://drive.google.com/file/d/1dahhjYsVuhK5oSvbzdvNpWQ1zIzuaAP5/view?usp=drive_link",
  portfolio_repository: "https://github.com/ashutosh1919/masterPortfolio",
  githubProfile: "https://github.com/lintsao",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/lintsao",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/ethen-tsao/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://youtube.com/c/DevSense19",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:ethentsao1998@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  // {
  //   name: "Twitter",
  //   link: "https://twitter.com/ashutosh_1919",
  //   fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
  //   backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  // },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/laymanbrother.19/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  // {
  //   name: "Instagram",
  //   link: "https://www.instagram.com/layman_brother/",
  //   fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //   backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  // },
];

const skills = {
  data: [
    {
      title: "Machine Learning",
      fileName: "MachineLearningImg",
      skills: [
        "⚡ Computer Vision Topics: Face Anti-Spoofing, Face Recognition, Head/Eye Redirection, Object Detection, Semantic Segmentation",
        "⚡ Natural Language Processing Topics: Question Answering",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "simple-icons:numpy",
          style: {
            backgroundColor: "transparent",
            color: "yellow",
          },
        },
        {
          skillName: "Jupyter",
          fontAwesomeClassname: "simple-icons:jupyter",
          style: {
            backgroundColor: "transparent",
            color: "#F37626",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Robotics",
      fileName: "RoboticsImg",
      skills: [
        "⚡ Sensing & Estimation Topics: Orientation Tracking, Particle Filter SLAM, Kalman Filter SLAM, Visual-Inertial SLAM",
        "⚡ Motion Planning & Control Topics: Dynamic Programming, A-Star, Rapidly-Exploring Random Tree (RRT), Markov Decision Process",
      ],
      softwareSkills: [
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#00599C",
          },
        },
        {
          skillName: "ROS",
          fontAwesomeClassname: "simple-icons:ros",
          style: {
            color: "#FFFFFF",
          },
        },
        {
          skillName: "OpenCV",
          fontAwesomeClassname: "simple-icons:opencv",
          style: {
            color: "#5C3EE8",
          },
        },
      ],
    },
    {
      title: "Cafe",
      fileName: "CafeImg",
      skills: [
        "⚡ Enjoy Espresso, Cappuccino, Latte, Americano, Mocha",,
      ],
      softwareSkills: [
      ],
    },
    {
      title: "Travel",
      fileName: "TravelImg",
      skills: [
        "⚡ Favorite Country: Taiwan 🇹🇼",
        "⚡ Visited Countries: Japan 🇯🇵, Singapore 🇸🇬, Indonesia 🇮🇩, United States 🇺🇸, Guam 🇬🇺, Thailand 🇹🇭, South Korea 🇰🇷, Australia 🇦🇺",
      ],
      softwareSkills: [
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/ltsao/",
    },

    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/b06901045dpgod",
    },
    
    {
      siteName: "Google Scholar",
      iconifyClassname: "simple-icons:googlescholar",
      style: {
        color: "#4285F4",
      },
      profileLink: "https://scholar.google.com/citations?user=eAZIiwcAAAAJ&hl=en&authuser=11",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of California, San Diego",
      subtitle: "M.S. in Electrical and Computer Engineering",
      logo_path: "ucsd_logo.png",
      alt_name: "UCSD",
      duration: "2022 - 2024",
      descriptions: [
        "⚡ Robotics-related Courses: Statistical Learning (ECE 271A), Stochastic Process & Dynamic Systems (ECE 272A), Sensing & Estimation in Robotics (ECE 276A), Planning & Learning in Robotics (ECE 276B)",
        "⚡ Machine learning-related Courses: Introduction to Visual Learning (ECE 285), Web Mining and Recommender Systems (CSE 285)",
        "⚡ Software-related Courses: Advanced Data Structures (CSE 100), Graduate Networked Systems (CSE 224)",
        "⚡ Extracurricular Activities: Participant @ English-in-Action (EIA) conversation program",
      ],
      website_link: "https://ucsd.edu/",
    },
    {
      title: "National Taiwan University",
      subtitle: "B.S. in Electrical Engineering",
      logo_path: "ntu_logo.png",
      alt_name: "NTU",
      duration: "2017 - 2021",
      descriptions: [
        "⚡ Robotics-related Courses: Robot Vision",
        "⚡ Machine learning-related Courses: Deep Learning for Computer Vision, Machine Learning",
        "⚡ Software-related Courses: Web Programming, Data Structure, Algorithms, Computer Architecture, Introduction to Computer, Computer Programming",
        "⚡ Extracurricular Activities: Public Relations Officer @ Pop Dance Club, Dance Team Leader @ Electrical Engineering Night, Participant @ NTU Creativity and Entrepreneurship Program",
      ],
      website_link: "https://www.ntu.edu.tw/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Research, and Leadership",
  description:
    "I have accumulated valuable research experiences in the fields of Machine Learning, Deep Learning, and Computer Vision. Presently, I am working as a research engineer intern at Futurewei Technologies, focusing specifically on gaze and head redirection. In addition to my research pursuits, I actively seek opportunities to engage in various leadership programs, allowing me to expand my knowledge and perspectives.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Video Processing & Computer Vision Research Engineer Intern",
          company: "Futurewei Technologies, Inc.",
          company_url: "https://www.futurewei.com/",
          logo_path: "futurewei_logo.png",
          duration: "June 2023 - Sep. 2023",
          location: "Santa Clara, CA",
          description:
            ["TBD"],
          color: "#FFFFFF",
        },
      ],
    },
    {
      title: "Research",
      work: true,
      experiences: [
        {
          title: "Computer Vision Research Assistant",
          company: "Vision and Learning Lab, NTU",
          company_url: "http://vllab.ee.ntu.edu.tw/",
          logo_path: "ntu_logo.png",
          duration: "Mar. 2020 – Jan. 2022",
          location: "Taipei, Taiwan",
          description:
            ["[Topic] Learning Facial Liveness Representation for Domain Generalized Face Anti-Spoofing",
            "• Designed a novel feature extractor model structure with the backbone of ResNet‑18 to solve domain generalized Face Anti‑Spoofing by disentangling facial liveness features and liveness‑irrelevant features.",
            "• Improved the Area under the ROC Curve (AUC) from 82.11% to 85.49% under the novel spoof attack detection and from 95.94% to 96.82% under the seen spoof attack detection compared with the current SOTA method.",
            "• Published the work at the IEEE International Conference on Multimedia & Expo (ICME), 2022."],
          color: "#0879bf",
        },
        {
          title: "Natural Language Processing Research Assistant",
          company: "Speech Processing and Machine Learning Lab, NTU",
          company_url: "https://speech.ee.ntu.edu.tw/~hylee/index.php",
          logo_path: "ntu_logo.png",
          duration: "Aug. 2021 – Jan. 2022",
          location: "Taipei, Taiwan",
          description:
            ["[Topic] Conversational Question Answering (QA) Machines on the ShARC Dataset",
            "• Implemented Transformer-based QA models combined with pre-trained language models as text encoders to answer users' questions given a rule document and a specific user scenario.",
            "• Improved the Micro Accuracy from 71.69% to 73.61% and the Macro Accuracy from 77.36% to 78.17%."],
          color: "#fc1f20",
        },
        {
          title: "Computer Vision Research Assistant",
          company: "Multimedia Processing and Communications Lab, NTU",
          company_url: "http://mpac.ee.ntu.edu.tw/",
          logo_path: "ntu_logo.png",
          duration: "Mar. 2021 – Aug. 2021",
          location: "Taipei, Taiwan",
          description:
            ["[Topic] Robust Masked Face Recognition via Balanced Feature Matching",
            "• Proposed the concept of balanced facial feature matching that helps extract features from certain facial regions.",
            "• Designed a masked face recognition system based on CNN as the facial feature extractors and the mask classifier.",
            "• Improved the Verification Accuracy from 80.2% to 85.6% and from 94.5% to 96.4% compared with the current face recognition model under two different real‑world masked face verification datasets.",
            "• Published the work at the IEEE International Conference on Consumer Electronics (ICCE), 2022."],
          color: "#9b1578",
        },
      ],
    },
    {
      title: "Leadership",
      experiences: [
        {
          title: "Member",
          company: "NTU Creativity and Entrepreneurship Program",
          company_url: "https://cep.ntu.edu.tw/",
          logo_path: "ntu_cep_logo.png",
          duration: "Sep. 2019 - June 2020",
          location: "Taipei, Taiwan",
          description:
            ["• Engaged in creative brainstorming and proposed a knowledge-based community platform reaching 3,000 people.",
             "• Developed a prototype based on Android studio to convert creativity into action."],
          color: "#4285F4",
        },
        {
          title: "Leader (dance team)",
          company: "Electrical Engineering Night (NTU)",
          company_url: "https://web.ee.ntu.edu.tw/",
          logo_path: "ntu_logo.png",
          duration: "Jan. – Mar. 2018/19/20",
          location: "Taipei, Taiwan",
          description:
            ["• Choreographed dance moves and coached students to perform on stage.",
            "• Developed transferable skills such as leadership, problem-solving, and decision-making."],
          color: "#D83B01",
        },
        {
          title: "Public Relations Officer",
          company: " Pop Dance Club (NTU)",
          company_url: "https://www.facebook.com/NTUPDC/",
          logo_path: "ntu_pdc_logo.png",
          duration: "Sep. 2018 - June 2019",
          location: "Taipei, Taiwan",
          description:
            ["• Collaborated with Rosy Rosa, a cosmetics company, to obtain sponsorship products.",
            "• Delivered dance performances to over 1,500 people in the final exhibition."],
          color: "#D83B01",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I developed several software projects related to Machine Learning, Computer Vision, and Robotics.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "",
      name: "Learning Facial Liveness Representation for Domain Generalized Face Anti‑Spoofing",
      createdAt: "26 August 2022, ICME",
      description: "Lin‑Hsi Tsao*, Zih‑Ching Chen*, Chin‑Lun Fu*, Shang‑Fu Chen, and Yu‑Chiang (Frank) Wang",
      url:
        "https://ieeexplore.ieee.org/document/9859916",
    },
    {
      id: "",
      name: "Robust Masked Face Recognition via Balanced Feature Matching",
      createdAt: "15 March 2022, ICCE",
      description: "Lin‑Hsi Tsao*, Yu‑Chieh Huang*, and Homer H. Chen",
      url:
        "https://ieeexplore.ieee.org/document/9730338",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "ethen.png",
    description:
      "I can be reached on a wide range of social media platforms, and you can expect a response from me within 24 hours. Feel free to reach out to me for discussion about projects related to machine learning (ML), artificial intelligence (AI), and robotics.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I love to record my travel experiences in the blog. Feel free to check it out!",
    link: "https://medium.com/@tsaolin",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "9500 Gilman Dr, La Jolla, CA 92093",
    // locality: "Kanodar",
    country: "United States",
    region: "California",
    postalCode: "92093",
    streetAddress: "9500 Gilman Dr, La Joll",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://www.google.com/maps/place/University+of+California+San+Diego/@32.884816,-117.2415438,16z/data=!4m10!1m2!2m1!1sUCSD!3m6!1s0x80dc06c4414caf4f:0xefb6aafc89913ea7!8m2!3d32.8800604!4d-117.2340135!15sCgRVQ1NEkgEKdW5pdmVyc2l0eeABAA!16zL20vMDd2am0?entry=ttu",
  },
  phoneSection: {
    title: "+1 (858) 431-6304",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
